import ButtonDialog from "@/components/ButtonDialog.vue";
import api from "@/api";
import DialogCustomView from "@/components/DialogCustomView.vue";
import BatterTableDataView from "@/components/BatterTableDataView.vue";
import { ElMessage } from "element-plus";
export default {
  name: "SiteCountdownArticleList",
  components: {
    BatterTableDataView,
    DialogCustomView,
    ButtonDialog
  },
  props: {
    siteId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [],
      cddId: null,
      addPageVisible: false
    };
  },
  methods: {
    previewHtml(d) {
      window.open(`/html/preview/${d.htmlId}?footer=${d.footId ? d.footId : ''}&page=${d.id}`, '_blank');
    },
    choose(pid) {
      api.addPageToCountDownDate({
        pageId: pid,
        dateId: this.cddId
      }).then(() => {
        ElMessage.success("添加成功");
      });
    },
    addPage(cddId) {
      this.cddId = cddId;
      this.addPageVisible = true;
    },
    deleteCountdownArticle(dateId, pageId) {
      api.deleteCountdownPage(dateId, pageId).then(() => this.init());
    },
    deleteCountdownDate(id) {
      api.deleteCountdownDate(id).then(() => this.init());
    },
    gotoEdit(d) {
      window.open('/html/edit/' + d.id, '_blank');
    },
    init() {
      this.addPageVisible = false;
      api.getSiteCountDownList(this.siteId).then(ret => {
        this.list = ret;
      });
    }
  },
  mounted() {
    this.init();
  }
};